import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared';

import { HomeService } from '../shared';
import { HomeComponent } from './home.component';
import { NguCarouselModule } from '@ngu/carousel';

@NgModule({
  imports: [ NguCarouselModule, SharedModule ],
  declarations: [
    HomeComponent
  ],
  providers: [
    HomeService
  ]
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts